import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store/index";
import Vuebar from "vuebar";
import "./plugins/base";
import VueSkycons from "vue-skycons";
import {BootstrapVue, IconsPlugin} from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import InstantSearch from "vue-instantsearch";
import api from "./api";
import bus from "./bus";
import InitController from "./utils/InitController"
import { puede, puedeVer } from "./utils/permisos";

Vue.use(VueSkycons, {
  color: "#1e88e5",
});
Vue.use(InstantSearch);

Vue.prototype.$bus = bus;
Vue.prototype.$api = api;
Vue.config.productionTip = false;

// Helper global de permisos: $puede('clientes','crear') / $puedeVer('clientes')
Vue.mixin({
  methods: {
    $puede: function (modulo, accion) {
      return puede(this.$store.getters.getInfoUser, modulo, accion);
    },
    $puedeVer: function (modulo) {
      return puedeVer(this.$store.getters.getInfoUser, modulo);
    },
  },
});
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(Vuebar);



//Definir inicio de sesion y otras cosas
InitController.start();

// or, using the defaults with no stylesheet 
new Vue({
  vuetify,
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");